"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.bradford.description': 'Brytyjski narrator, ekspresyjny i angażujący.',
};
